"use client";

import { PageDecorLayer } from "@/components/decorative/PageDecorLayer";
import { ContactGlassFormCard } from "@/components/contact/premium/ContactGlassFormCard";
import { ContactInfoPremiumPanel } from "@/components/contact/premium/ContactInfoPremiumPanel";
import { Stagger, StaggerItem } from "@/components/motion";

export function ContactPremiumSection() {
  return (
    <section className="relative overflow-hidden border-t border-[var(--contact-border)] bg-[var(--contact-section-bg)] py-16 md:py-24">
      <PageDecorLayer variant="section" />

      <div
        aria-hidden
        className="pointer-events-none absolute inset-x-0 bottom-0 h-24 bg-gradient-to-b from-transparent to-[var(--background)] opacity-60"
      />

      <div className="relative z-10 mx-auto max-w-7xl px-4 md:px-6">
        <Stagger className="grid gap-8 lg:grid-cols-2 lg:items-start lg:gap-12">
          <StaggerItem>
            <ContactInfoPremiumPanel />
          </StaggerItem>
          <StaggerItem>
            <ContactGlassFormCard source="contact" />
          </StaggerItem>
        </Stagger>
      </div>
    </section>
  );
}
